module.exports = __webpack_public_path__ + "img/shutterbug.1990bbc9.jpg";